import React from 'react'
import { titleCase } from 'change-case'
import { TextWithOverflowTooltip } from '../../../components/TextWithOverflowTooltip'

interface Props {
  error: object
}
const ListingErrorWithOverflowTooltip: React.FC<Props> = ({ error }): JSX.Element | null => {
  if (!error) return null
  return (
    <>
      {Object.keys(error).map(err => (
        <div key={err}>
          <TextWithOverflowTooltip
            label={`${titleCase(err)} ${' '} ${error[err]}`}
            tooltipContent={`${titleCase(err)} ${' '} ${error[err]}`}
          />
        </div>
      ))}
    </>
  )
}
export default ListingErrorWithOverflowTooltip
